<div id="header">
  <div class="non-title-container">
    <button
      id="header-menu-button"
      (click)="sideNavigatorService.toggleSideNavigator()"
    >
      <img src="assets/redesign/home/menu-icon.svg" alt="Menu" />
    </button>
  </div>
  <div id="title-container">
    <div id="header-branding">
      <!-- <img
        id="header-branding-icon"
        src="assets/redesign/home/default-logo.svg"
        alt="MedicNow"
      /> -->
      <span class="header-title">Medic Now</span>
    </div>
  </div>
  <div class="right-container">
    <img
      id="header-org-badge"
      [src]="organizationLogoUrl | safeUrl"
      alt="Organization"
      (error)="onBadgeImageError()"
    />
  </div>
</div>
